module.exports = __webpack_public_path__ + "img/top_background.81b4bf05.jpg";